import { createFileRoute } from "@tanstack/react-router";
import { Keypad, KeyPadHeader } from "../features/login";
import { SignInPage } from "../forms/signin";
import { Toaster } from "../components/shad/sonner";

export const Route = createFileRoute("/")({
  component: Index,
});

function Index() {
  return (
    <div className="h-screen xw-screen overflow-hidden flex flex-col justify-center items-center">
      <div className="w-full max-w-md p-3 pb-0 bg-base-50 text-center">
        {/*<KeyPadHeader />
        <Keypad />*/}
        <SignInPage />
        {/*<div className="py-4 h-8 text-sm text-base-500">
          {process.env.NODE_ENV === "development" && <p>Development Mode</p>}
        </div>*/}
      </div>
      <Toaster />
    </div>
  );
}
